import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import Info from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTableActionStyles } from "./styles";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Cancellation } from "../../../../../@types/cancellation";

type Props = {
    id: Cancellation['id'];
}

export default function ListTableActions({ id }: Props) {
    const { pathname } = useLocation();
    const { classes } = useTableActionStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} >
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${id}`}
                >
                    <Info htmlColor="#706E7A" />
                    Informações
                </MenuItem>
            </Menu>
        </>
    );
}